<template>
	<div>
		<!-- Navigation -->
		<navigation
			@prev="$emit('prev')"
			@next="$emit('next')"
			:activeStepIndex="activeStepIndex"
			:$v="$v"
			:processing-api="processingApi"
		/>

		<!-- Form -->
		<div class="form-group">
			<label
				:class="survey.id == 552 ? 'color-avai' : 'black'"
				class="title-bold"
				for="nome"
			>
				{{ $t("enter_cel_number") }}
			</label>

			<!-- Error messages -->
			<div class="error mt-n2 d-flex flex-column mb-2">
				<span
					v-if="$v.selectedPhoneCode.$error && !$v.selectedPhoneCode.required"
				>
					{{ "DDI " + $t("is_required") }}
				</span>
				<span v-if="$v.localPhone.$error">
					{{ $t("cel") }}
					<span v-if="!$v.localPhone.required">{{ $t("is_required") }}</span>
					<span v-else-if="!$v.localPhone.minLength">{{ $t("invalid") }}</span>
				</span>
			</div>

			<div class="d-flex">
				<div class="ddi-input">
					<input
						list="countries"
						class="form-control mr-3"
						:placeholder="$t('registration_phoneCode')"
						id="phoneCodeInput"
						v-mask="'+###'"
						v-model="selectedPhoneCode"
						@blur="$v.selectedPhoneCode.$touch()"
					/>
					<datalist id="countries">
						<option
							class="text-black"
							v-for="(country, index) in countriesSorted"
							:value="'+' + country.phone_Code"
							:key="index"
						>
							{{ country.country_Name }}
						</option>
					</datalist>
				</div>

				<input
					v-if="selectedPhoneCode === '+55'"
					type="text"
					class="form-control"
					id="cel"
					placeholder="(##) #####-####"
					v-model.number="localPhone"
					v-mask="'(##) #####-####'"
					@keyup.enter="goToNextStep"
					@blur="$v.localPhone.$touch()"
				/>
				<input
					v-else
					type="text"
					class="form-control"
					id="cel"
					:placeholder="$t('registration_number')"
					v-model.number="localPhone"
					@keyup.enter="goToNextStep"
					@blur="$v.localPhone.$touch()"
				/>
			</div>
		</div>

		<section class="row">
			<div class="col-12 mt-5 mx-auto col-md-6">
				<button
					:style="{
						backgroundColor: style.surveyBtnColor || style.homeBtnColor,
					}"
					type="submit"
					class="w-100 btn btn-primary btn-block my-3"
					@click="goToNextStep"
					:disabled="$v.$invalid || processingApi"
				>
					{{ $t("advance") }}
					<span
						class="spinner-border spinner-border-sm"
						role="status"
						aria-hidden="true"
						v-if="processingApi"
					></span>
				</button>
			</div>
		</section>
	</div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { minLength, required } from "vuelidate/lib/validators";
import Navigation from "@/components/registration/components/Navigation";
import { mask } from "vue-the-mask";
import { Fanbase } from "../../services/Fanbase";

const f = new Fanbase();

export default {
	name: "Register-Phone",
	components: { Navigation },
	props: {
		profile: { type: Object, required: true },
		processingApi: { type: Boolean, required: true },
		activeStepIndex: { type: Number, required: true },
	},
	data() {
		return {
			localPhone: "",
			selectedPhoneCode: "",
		};
	},
	watch: {
		selectedPhoneCode(newVal, oldVal) {
			if (newVal !== oldVal) this.updatePhoneNumber();
			this.SET_SavedPhoneCode(newVal);
		},
		localPhone(newVal, oldVal) {
			if (newVal !== oldVal) this.updatePhoneNumber();
			this.SET_SavedPhoneNumber(newVal);
		},
	},
	directives: { mask },
	validations: {
		selectedPhoneCode: { required, minLength: minLength(2) },
		localPhone: { required, minLength: minLength(5) },
	},
	computed: {
		...mapState(["countries", "savedPhoneCode", "savedPhoneNumber"]),
		fullPhoneNumber() {
			return `${this.selectedPhoneCode} ${this.localPhone}`.trim();
		},
		style() {
			return this.$store.state.template.style;
		},
		survey() {
			return this.$store.state.template.survey;
		},
		countriesSorted() {
			return this.countries.slice().sort((a, b) => {
				return a.country_Name.localeCompare(b.country_Name, "pt");
			});
		},
	},
	async created() {
		try {
			const data = await f.GetCountries();
			this.$store.dispatch("setCountries", data);
		} catch (err) {
			console.error(this.$t("registration_country_errors_1"), err);
			this.$vs.notify({
				color: "RGBA(255,0,0)",
				title: this.$t("registration_country_errors_2"),
				text: "",
				time: 5000,
			});
		} finally {
			this.processing = false;
		}
		if (this.savedPhoneCode && this.savedPhoneNumber) {
			this.selectedPhoneCode = this.savedPhoneCode;
			this.localPhone = this.savedPhoneNumber;
		}
	},
	mounted() {
		this.$nextTick(() => {
			if (this.activeStepIndex !== 0) this.focusOn("cel");
		});
	},
	methods: {
		...mapMutations(["SET_SavedPhoneCode", "SET_SavedPhoneNumber"]),
		updatePhoneNumber() {
			if (this.profile.Numbers?.[2]) {
				this.profile.Numbers[2].Number = this.fullPhoneNumber;
			}
		},
		focusOn(el) {
			document.getElementById(el)?.focus();
		},
		goToNextStep() {
			if (!this.$v.$invalid) {
				this.$emit("next");
			}
		},
	},
};
</script>

<style scoped>
.color-avai {
	color: #123654 !important;
}
.ddi-input {
	width: 150px;
}
</style>
